import React from 'react';
import CrawlJobCard from './CrawlJobCard';

export default function CrawlJobList({ jobs, onDelete, onRefresh, onRestart, onMarkCompleted }) {
  if (!jobs || jobs.length === 0) return <div>크롤링 작업이 없습니다.</div>;
  return (
    <div>
      {jobs.map((job) => (
        <CrawlJobCard
          key={job.crawl_id}
          job={job}
          onDelete={onDelete}
          onRefresh={onRefresh}
          onRestart={onRestart}
          onMarkCompleted={onMarkCompleted}
        />
      ))}
    </div>
  );
} 